import React from "react";
import { FadeUp } from "@/components/motion";

/**
 * Live responsive demo of the Elegant example ad. The browser picks the
 * correct GIF for the current viewport via <picture> media queries — exactly
 * how the unit behaves on WhichSchoolAdvisor.com and SchoolsCompared.com.
 * Breakpoints mirror the min-screen column in the ad sizes table.
 */
const SOURCES = [
  { media: "(min-width: 1248px)", src: "/examples/wm-example-elegant-s5.gif", w: 1216, h: 168 },
  { media: "(min-width: 992px)", src: "/examples/wm-example-elegant-s4.gif", w: 960, h: 168 },
  { media: "(min-width: 752px)", src: "/examples/wm-example-elegant-s3.gif", w: 720, h: 168 },
  { media: "(min-width: 624px)", src: "/examples/wm-example-elegant-s2.gif", w: 592, h: 168 },
];

const ServingLabel = () => (
  <p className="font-mono text-[10px] uppercase tracking-widest text-foreground/50 text-center mt-3" data-testid="responsive-ad-serving">
    Currently serving:
    <span className="hidden min-[1248px]:inline"> Size 5 · 1216 × 168</span>
    <span className="hidden min-[992px]:max-[1247px]:inline"> Size 4 · 960 × 168</span>
    <span className="hidden min-[752px]:max-[991px]:inline"> Size 3 · 720 × 168</span>
    <span className="hidden min-[624px]:max-[751px]:inline"> Size 2 · 592 × 168</span>
    <span className="hidden max-[623px]:inline"> Size 1 · 328 × 272</span>
    {" "}— resize your browser to watch it respond
  </p>
);

const ResponsiveAdDemo = () => (
  <section data-testid="responsive-ad-demo" className="mx-auto max-w-[1400px] px-5 md:px-8 pt-20 md:pt-28">
    <FadeUp>
      <p className="font-mono text-[10px] uppercase tracking-widest text-foreground/50 text-center mb-3">
        Advertisement · live example
      </p>
      <div className="flex justify-center">
        <picture>
          {SOURCES.map((s) => (
            <source key={s.media} media={s.media} srcSet={s.src} width={s.w} height={s.h} />
          ))}
          <img
            src="/examples/wm-example-elegant-s1.gif"
            width={328}
            height={272}
            alt="Which Media Elegant example ad — a five-message GIF served in five responsive sizes"
            className="max-w-full h-auto rounded-md shadow-sm"
            data-testid="responsive-ad-demo-img"
          />
        </picture>
      </div>
      <ServingLabel />
    </FadeUp>
  </section>
);

export default ResponsiveAdDemo;
